// extracted by mini-css-extract-plugin
module.exports = {"pageName":"StoreForecast_pageName__3Ufk4"};